







import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'
const echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

@Component({
  components: {}
})
export default class ClassAttempt extends ViewBase {
  @Prop({ default: null }) pointsTryCount!: any
  lang: any = {}
  echartSource: any = []
  // 鼠标指到柱状图上的提示文字
  textArr: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }
  setSource() {
    const pointsTryCount = this.pointsTryCount
    const arr = []
    const textArr = []
    let index = 0
    for (const key of Object.keys(pointsTryCount)) {
      // 鼠标指上去的提示文字
      const textObj: any = {
        max: {},
        min: {},
        avg: {}
      }
      // echarts绘制对象
      const obj: any = {}
      obj.product = pointsTryCount[key].k_name
      obj.max = parseInt(pointsTryCount[key].max.num, 10)
      obj.min = parseInt(pointsTryCount[key].min.num, 10)
      obj.avg = parseInt(pointsTryCount[key].avg.num, 10)
      obj.index = index++
      arr.push(obj)
      textObj.max.text = pointsTryCount[key].max.cid_name_list
      textObj.max.num = pointsTryCount[key].max.num
      textObj.min.text = pointsTryCount[key].min.cid_name_list
      textObj.min.num = pointsTryCount[key].min.num
      textObj.avg.text = pointsTryCount[key].avg.cid_name_list
      textObj.avg.num = pointsTryCount[key].avg.num
      textArr.push(textObj)
      this.textArr = textArr
      this.echartSource = arr
    }
    this.setAttempt()
  }

  // 尝试次数
  setAttempt() {
    const myChart = echarts.init(this.$refs.attempt)
    const that = this
    const option = {
      legend: {
        x: 'center'
      },
      tooltip: {
        trigger: 'item' /*此处为item*/,
        axisPointer: {
          type: 'line'
        },
        formatter(params: any, trigger: any) {
          const index = params.value.index
          const textKey = params.dimensionNames[params.encode.y[0]]
          return `<div style="text-align:center">${that.textArr[index][textKey].text},${that.textArr[index][textKey].num}</div>`
        }
      },
      dataset: {
        dimensions: ['product', 'max', 'min', 'avg'],
        source: that.echartSource
      },
      xAxis: {
        type: 'category',
        name: that.lang.xAxisText,
        nameLocation: 'center',
        nameTextStyle: { padding: 10 }
      },
      yAxis: {
        name: that.lang.cNum,
        nameLocation: 'end'
      },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          barGap: 0,
          name: that.lang.maxTest,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#70AD47'
            }
          }
        },
        {
          name: that.lang.minTest,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#4472C4'
            }
          }
        },
        {
          name: that.lang.averageTest,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#FFC000'
            }
          }
        }
      ]
    }

    // 绘制图表
    myChart.setOption(option)
  }
  created() {
    this.lang = this.i18n.vStudy
    setTimeout(() => {
      this.setSource()
    })
  }
}
